import { render, staticRenderFns } from "./consultantfarmerrelations.vue?vue&type=template&id=26219407&"
import script from "./consultantfarmerrelations.vue?vue&type=script&lang=js&"
export * from "./consultantfarmerrelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports